import apiClient from '~/config/apiClient';

import { AppSettingsDto } from './types';

export const getAppSettings = (appName: string) => {
  return apiClient.get<AppSettingsDto>(`/app-setting`, {
    params: {
      appName,
    },
  });
};
